<mat-tab-group>
  <mat-tab label="Booth Server">
    <table mat-table [dataSource]="boothDatasource">
      <ng-container matColumnDef="player">
        <th mat-header-cell *matHeaderCellDef>Player</th>
        <td mat-cell *matCellDef="let p">
      <span style="display: flex; align-items: center">
        <img src="https://mc-heads.net/avatar/{{p.uuid}}/20"> &nbsp;
        {{p.lastUsername}}
      </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="rank">
        <th mat-header-cell *matHeaderCellDef>Rank</th>
        <td mat-cell *matCellDef="let p">
          {{p.rank.name}}
        </td>
      </ng-container>
      <ng-container matColumnDef="lastseen">
        <th mat-header-cell *matHeaderCellDef>Last Seen</th>
        <td mat-cell *matCellDef="let p">
          {{ formatLastSeen(p.lastSeen) }}
        </td>
      </ng-container>
      <ng-container matColumnDef="onlinetime">
        <th mat-header-cell *matHeaderCellDef>Online Time</th>
        <td mat-cell *matCellDef="let p">
          {{ formatDuration(p.onlineTime) }}
        </td>
      </ng-container>
      <ng-container matColumnDef="teleported">
        <th mat-header-cell *matHeaderCellDef># Teleported</th>
        <td mat-cell *matCellDef="let p">
          {{p.teleported}}
        </td>
      </ng-container>
      <ng-container matColumnDef="approved">
        <th mat-header-cell *matHeaderCellDef># Approved</th>
        <td mat-cell *matCellDef="let p">
          {{p.approved}}
        </td>
      </ng-container>
      <ng-container matColumnDef="denied">
        <th mat-header-cell *matHeaderCellDef># Denied</th>
        <td mat-cell *matCellDef="let p">
          {{p.denied}}
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="boothColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: boothColumns" routerLink="/players/{{row.uuid}}"></tr>
    </table>
  </mat-tab>
  <mat-tab label="Event Server">
<table mat-table [dataSource]="datasource">
  <ng-container matColumnDef="player">
    <th mat-header-cell *matHeaderCellDef>Player</th>
    <td mat-cell *matCellDef="let p">
      <span style="display: flex; align-items: center">
        <img src="https://mc-heads.net/avatar/{{p.uuid}}/20"> &nbsp;
        {{p.lastUsername}}
      </span>
    </td>
  </ng-container>
  <ng-container matColumnDef="rank">
    <th mat-header-cell *matHeaderCellDef>Rank</th>
    <td mat-cell *matCellDef="let p">
      {{p.rank.name}}
    </td>
  </ng-container>
  <ng-container matColumnDef="onlinetime">
    <th mat-header-cell *matHeaderCellDef>Online Time</th>
    <td mat-cell *matCellDef="let p">
      {{ formatDuration(p.onlineTime) }}
    </td>
  </ng-container>
  <ng-container matColumnDef="afktime">
    <th mat-header-cell *matHeaderCellDef>AFK Time</th>
    <td mat-cell *matCellDef="let p">
      {{ formatDuration(p.afkTime) }}
    </td>
  </ng-container>
  <ng-container matColumnDef="lastseen">
    <th mat-header-cell *matHeaderCellDef>Last Seen</th>
    <td mat-cell *matCellDef="let p">
      {{ formatLastSeen(p.lastSeen) }}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns" routerLink="/players/{{row.uuid}}"></tr>
</table>
  </mat-tab>
</mat-tab-group>
